import "antd/es/tree-select/style";
import _TreeSelect from "antd/es/tree-select";
import withFieldWrap from '../../utils/withFieldWrap';
export default withFieldWrap(_TreeSelect);